import Home from './components/Home.vue';
import Login from './components/login/Login.vue';
import ResetPassword from './components/resetPassword/Reset.vue';
import NeueBeteiligung from './components/neue_beteiligung/Neue.vue';
import Ablehnen from './components/ablehnen/Ablehnen.vue';
import MeineTrends from './components/meine_trends/Meine_trends';
import Konto from './components/konto/Konto';
import Filter_wahlen from './components/filter_wahlen/Filter_wahlen';
import Calendar from './components/meine_trends/Alle_release';
import Guthaben from './components/konto/Guthaben_auszahlen';
import Konto_detail from './components/konto/Konto_detail';
import Profil from './components/profil/Profil';

export const routes = [
    { path: '/', component: Home  },
    { name: 'login', path: '/login', component: Login },
    { name: 'reset', path: '/reset_password', component: ResetPassword },
    { name: 'neue_beteiligung', path: '/neue_beteiligung', component: NeueBeteiligung },
    { name: 'ablehnen', path: '/neue_ablehnen', component: Ablehnen },
    { name: 'meine_trends', params: {menu: 'true'}, path: '/meine_trends', component: MeineTrends},
    { name: 'konto', path: '/konto',params: {menu: 'true'}, component: Konto },
    { name: 'filter_wahlen', path: '/filter_wahlen', component: Filter_wahlen },
    { name: 'calendar', path: '/calendar', component: Calendar },
    { name: 'guthaben_auszahlen', path: '/guthaben_auszahlen', component: Guthaben },
    { name: 'konto_detail', path: '/konto_detail', component: Konto_detail },
    { name: 'profil', path: '/profil', component: Profil }
];



// WEBPACK FOOTER //
// ./src/routes.js